export const stringToColor = (str: string) => {
  const hash = Array.from(str).reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const h = ((hash % 360) % 300) + 20;
  const s = 85 + (hash % 10) + '%';
  const l = 33 + (hash % 5) + '%';
  return `hsl(${h}, ${s}, ${l})`;
};
